var _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6072,
    cy: 2.80748,
    r: 2.60045,
    fill: "#FFC130"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1874 6.00382C23.1285 6.01032 23.0924 6.0464 23.079 6.11217C26.7261 6.22052 27.3515 6.26893 31 6.23285C31 7.38864 31 8.54433 31 9.70012C30.886 9.68397 30.7777 9.70196 30.6749 9.75429C30.8248 9.89201 30.9331 10.0545 31 10.2419C31 10.9281 31 11.6144 31 12.3006C26.4492 12.3006 24.921 12.2882 20.3702 12.2882C20.3702 13.6245 20.3702 14.961 20.3702 16.2973C18.1253 16.2143 15.9221 16.4671 13.7607 17.0557C13.7262 17.5827 13.7622 18.0883 13.8691 18.5727C13.8626 18.6315 13.8265 18.6676 13.7607 18.681C13.6705 16.8401 13.6163 14.9981 13.5982 13.1551C12.474 14.4602 11.5711 15.9048 10.8894 17.4891C10.8003 17.7727 10.7461 18.0617 10.7269 18.356C9.56695 18.8096 8.48343 19.4056 7.4763 20.1438C6.30003 21.1218 5.18042 22.1511 4.11738 23.2318C4.15303 21.8401 4.11684 20.4676 4.00903 19.1144C3.93221 18.0349 3.62514 17.0237 3.08804 16.0806C2.07191 14.6804 1.04256 13.2899 0 11.909C2.41831 13.2017 4.82015 14.5561 7.20542 15.9722C9.32544 14.7587 11.4383 13.5306 13.544 12.2882C13.6704 10.8811 13.6885 9.4725 13.5982 8.06251C12.5822 6.59022 11.5528 5.12747 10.5102 3.67425C11.9701 4.40497 13.4148 5.19952 14.8442 6.05799C16.7585 6.13026 18.6726 6.13026 20.5869 6.05799C22.0405 5.25012 23.467 4.4014 24.8668 3.51172C24.3439 4.34625 23.7842 5.17698 23.1874 6.00382Z",
    fill: "#FFC130"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.7945,
    cy: 8.98424,
    r: 2.60045,
    fill: "#049645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5981 16.1899C37.6461 15.3946 38.6935 14.5999 39.7403 13.8061C42.026 12.5154 44.3014 11.1972 46.5665 9.85126C46.7029 9.74486 46.8474 9.70878 46.9999 9.74291C46.0657 10.9793 45.1447 12.2254 44.2369 13.4811C43.8885 14.1056 43.5995 14.7557 43.3701 15.4314C43.2297 19.5452 43.1574 23.6626 43.1534 27.7835C42.6241 34.3082 39.0846 37.631 32.5349 37.7519C28.952 37.8201 26.0265 36.4837 23.7584 33.7429C23.2504 33.0176 22.835 32.241 22.5123 31.4133C24.4141 30.1996 26.3464 29.0257 28.3092 27.8919C29.1914 31.1054 31.232 32.2069 34.4311 31.1966C35.8097 30.4463 36.514 29.2724 36.5439 27.6752C36.5981 23.8469 36.6162 20.0185 36.5981 16.1899Z",
    fill: "#049645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0226 9.68834C33.0716 9.79214 33.1438 9.88251 33.2393 9.95922C35.453 11.1834 37.6201 12.4656 39.7404 13.8057C38.6936 14.5995 37.6462 15.3942 36.5982 16.1895C36.4062 15.2636 36.063 14.3968 35.5688 13.589C34.7349 12.4494 33.8861 11.3298 33.0226 10.2301C32.9557 10.0428 32.8474 9.88023 32.6975 9.74252C32.8002 9.69018 32.9086 9.6722 33.0226 9.68834Z",
    fill: "#049645"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3702 16.2976C20.3702 16.5504 20.3702 16.8033 20.3702 17.0561C18.1456 17.3233 15.9786 17.829 13.8691 18.573C13.7622 18.0887 13.7262 17.583 13.7607 17.0561C15.9221 16.4674 18.1253 16.2146 20.3702 16.2976Z",
    fill: "#FFC130"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7269 18.3564C10.5643 19.0607 10.4013 19.8595 10.2935 20.4693C7.86778 21.8836 6.06199 23.3825 4.22575 25.5077C4.11837 24.7695 4.08218 24.011 4.1174 23.2323C5.18044 22.1516 6.30004 21.1222 7.47632 20.1443C8.48345 19.4061 9.56697 18.8101 10.7269 18.3564Z",
    fill: "#FFC130"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5552 23.8831C27.1602 23.8831 23.7651 23.8831 20.3701 23.8831C20.3701 28.4339 20.3701 32.9847 20.3701 37.5355C18.167 37.5355 15.9638 37.5355 13.7607 37.5355C13.7967 32.1535 13.7607 26.772 13.6523 21.391C13.5865 21.4044 13.5504 21.4405 13.5439 21.4994C12.5631 22.0973 11.6241 22.7475 10.7268 23.4497C10.6185 28.1265 10.5825 32.8218 10.6184 37.5355C8.4514 37.5355 6.28435 37.5355 4.11731 37.5355C4.11731 33.9959 4.11731 30.4565 4.11731 26.917C8.23588 21.7139 13.6174 18.698 20.2618 17.8696C23.6928 17.8154 27.1239 17.7973 30.5552 17.8154C30.5552 19.838 30.5552 21.8605 30.5552 23.8831Z",
    fill: "#049645"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00889 19.1143C4.1167 20.4675 4.15289 21.84 4.11724 23.2316C4.08203 24.0104 4.11822 24.7688 4.22559 25.507C4.21909 25.5659 4.18301 25.602 4.11724 25.6154C4.00889 23.4495 3.97281 21.2825 4.00889 19.1143Z",
    fill: "#FFC130"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5441 21.498C13.5506 21.4392 13.5866 21.4031 13.6524 21.3896C13.7608 26.7706 13.7969 32.1522 13.7608 37.5341C15.9639 37.5341 18.1671 37.5341 20.3703 37.5341C20.3703 37.5702 20.3703 37.6064 20.3703 37.6425C18.1309 37.6425 15.8917 37.6425 13.6524 37.6425C13.6884 32.2426 13.6523 26.8611 13.5441 21.498Z",
    fill: "#049645"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5553 23.8818C27.215 23.99 23.856 24.0261 20.4786 23.9902C20.5146 28.5594 20.4785 33.1102 20.3702 37.6426C20.3702 37.6065 20.3702 37.5703 20.3702 37.5342C20.3702 32.9834 20.3702 28.4326 20.3702 23.8818C23.7652 23.8818 27.1603 23.8818 30.5553 23.8818Z",
    fill: "#049645"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7269 23.4492C10.7269 28.1806 10.7269 32.9119 10.7269 37.6433C8.48758 37.6433 6.24837 37.6433 4.00906 37.6433C3.97309 34.0492 4.00927 30.4736 4.11741 26.9165C4.11741 30.456 4.11741 33.9955 4.11741 37.535C6.28445 37.535 8.4515 37.535 10.6185 37.535C10.5826 32.8214 10.6186 28.126 10.7269 23.4492Z",
    fill: "#049645"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.98876,
    cy: 10.9344,
    r: 2.60045,
    fill: "#FFC130"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 9,
    width: 1,
    height: 1,
    fill: "#FFC130"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 1,
    height: 1,
    fill: "#FFC130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7c55af04923516551bb9525574330903.svg";
export { ForwardRef as ReactComponent };